import React, { useRef, SyntheticEvent } from 'react'
import { InputGroup, Intent } from '@blueprintjs/core'
import { IconButton } from '@ui'

const copy = (e: any, current: HTMLInputElement | null) => {
  current?.select()
  document.execCommand('copy')
  e.target.focus()
}

export default function IntegrationInputGroup(inputProps: any) {
  const inputRef = useRef<HTMLInputElement | null>(null)

  return (
    <InputGroup
      id={inputProps.name}
      inputRef={(ref) => (inputRef.current = ref)}
      intent={inputProps.hasError ? Intent.DANGER : Intent.NONE}
      disabled={inputProps.disabled}
      value={inputProps.value}
      onFocus={inputProps.onFocus}
      onBlur={inputProps.onBlur}
      onChange={(e: SyntheticEvent<HTMLInputElement>) => {
        !inputProps.readonly && !inputProps.generatoable && inputProps.onChange(e)
      }}
      rightElement={
        <>
          {inputProps.generatoable && (
            <IconButton
              minimal
              iconName="sync"
              tooltip="Regenerate"
              round={false}
              onClick={inputProps.regenerateToken}
            />
          )}
          {inputProps.value && !inputProps.value.match(/^\*+$/) && (
            <IconButton
              minimal
              iconName="copy"
              tooltip="Copy to clipboard"
              onClick={(e: any) => copy(e, inputRef.current)}
            />
          )}
        </>
      }
    />
  )
}
